/// <reference path="../../../typings/createjs/createjs.d.ts" />

export class ImageEditorCanvas{
    protected stage: createjs.Stage;
    protected canvas: HTMLCanvasElement;
    protected imageWidth:number;
    protected imageHegiht:number;
    protected bitmap:createjs.Bitmap;
    protected scale:number;
    protected x:number;
    protected y:number;

    constructor(x:number, y:number, width:number, height:number, img:string, scale:number){
        var canvas:HTMLCanvasElement = <HTMLCanvasElement>document.getElementById('image_editor');
        if ( canvas === null ) {
            return;
        }
        this.scale = scale;
        this.initCanvas(canvas);
        createjs.Ticker.setFPS(25);
        createjs.Ticker.on('tick', (e: createjs.TickerEvent) => { this.onEnterFrame(e) });

        this.canvas.width = width;
        this.canvas.height = height;
		this.x = x;
		this.y = y;
        var image = new Image();
        image.onload = (evt) =>{
            this.handleImageLoad(evt);
        };
        image.src = img;
        this.addItemsToStage();
        this.stage.update();
    }

    private initCanvas(canvas:HTMLCanvasElement):void{
        this.canvas = canvas;
        this.canvas.style.background = '#fff';
        this.stage = new createjs.Stage(this.canvas);
        createjs.Touch.enable(this.stage);
        this.stage.enableMouseOver(10);
        this.stage.mouseMoveOutside = true;
    }

    private addItemsToStage():void{

    }

    private resfhresScale():void{
        this.bitmap.scaleX = this.scale;
        this.bitmap.scaleY = this.scale;
    }

	public resizeImage(percent:number):void{
        if ( this.bitmap !== undefined  && this.bitmap.x !== undefined ) {
            this.scale = percent/100;
            this.bitmap.x = 0;
            this.bitmap.y = 0;
    		this.resfhresScale();
        }
	}

    private onEnterFrame(e: createjs.TickerEvent): void {
        this.stage.update(e);
    }

    private handleImageLoad(event): void {
        var image = event.target;
        this.imageWidth = image.width;
        this.imageHegiht = image.height;
    	var container = new createjs.Container();
    	this.stage.addChild(container);

		this.bitmap = new createjs.Bitmap(image);
		this.bitmap.name = "image";
		this.bitmap.cursor = "pointer";
		this.bitmap.x = this.x;
		this.bitmap.y = this.y;

		this.bitmap.on("mousedown", (evt:any) => {
            var t = evt.target;
			t.offset = {x: t.x - evt.stageX, y: t.y - evt.stageY};
		});

		this.bitmap.on("pressmove", (evt:any) => {
            var t = evt.target;
			var newX:number = evt.stageX + t.offset.x;
			var newY:number = evt.stageY + t.offset.y;
			var scale:number = this.scale;
			if ( this.imageWidth * scale < this.canvas.width ) {
				// kisebb
				if ( newX >= 0 && (newX + this.imageWidth*scale) <= this.canvas.width ) {
	                t.x = newX;
	            }
			}else{
				// nagyobb
	            if ( newX < 0  && (newX + this.imageWidth*scale) > this.canvas.width ) {
	                t.x = newX;
	            }
			}

			if ( this.imageHegiht*scale < this.canvas.height ) {
				// kisebb
	            var bottomBorder:number = this.canvas.height- this.imageHegiht*scale ;
	            if ( newY >= 0 && newY <= bottomBorder ) {
	                t.y = newY;
	            }
			}else{
				// nagyobb
	            if ( newY < 0  && (newY + this.imageHegiht*scale) > this.canvas.height ) {
	                t.y = newY;
	            }
			}
			this.x = t.x;
			this.y = t.y;
		});

		// bitmap.on("rollover", function (evt) {
		// });
        //
		// bitmap.on("rollout", function (evt) {
		// });
        this.resfhresScale();
        container.addChild(this.bitmap);
    }

	public getParameters():any{
		return {
			x: this.x,
			y: this.y,
            scale: this.scale
		}
	}
}



// WEBPACK FOOTER //
// ./lib/components/ImageEditorCanvas.ts